import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dedda82af2851e/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dedda82af2851e/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8dedda82af2851e/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dedda82af2851e/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dedda82af2851e/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/app/[locale]/industries/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedda82af2851e/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
